var React = require('react');
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import FolderIcon from '@mui/icons-material/Folder';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined';
import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';
import PostAddOutlinedIcon from '@mui/icons-material/PostAddOutlined';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import ReceiptIcon from '@mui/icons-material/Receipt';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { Link, useHistory } from 'react-router-dom';
import Home from '../Home';
import BillingTabs from './Site';
import TaskTabs from './Tasks';
import SummaryTabs from './Summary';
import UserTabs from './Users';
import ReportTabs from './Reports';
import ImportTabs from './Import';
import EventTabs from './Events';
import { logger } from '../utils';


const drawerWidth = 180;

function ResponsiveDrawer(props) {
  const { window } = props;
  const [refresh, setRefresh] = React.useState(true);
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [permissions, setPermissions] = React.useState({});
  const [component, setComponent] = React.useState('summary');
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  
  React.useEffect(() => {
            if (refresh) {
            fetch('/api/User/Permission')
                .then(res => res.json())
                .then(json => setPermissions(json))
                .then(json => logger(json))

            setRefresh(false);
        }
  
    })
  
  const drawer = (
    <div>
      <Toolbar />
      <Divider />
      <List>
  		<ListItem button onClick= {() => setComponent('home')}>
          <ListItemIcon>
             <HomeOutlinedIcon/>                      
          </ListItemIcon>
              <ListItemText primary={
                  <Link to="/Home" style={{ textDecoration: 'none' }}>
	                  <Typography variant="h6" style={{ color: "black" }}>
	                      Home
	                  </Typography>
                  </Link>
					/*<Button
						className="navBarButton"
						component={Link}
						key='Home'
						sx={{ my: 2, color: 'black', display: 'block' }}
						to='/Home'
					>
						<Typography textAlign="center" variant="h6">Home</Typography>
					</Button>*/
              } />
          </ListItem>
          <ListItem button onClick= {() => setComponent('summary')}>
              <ListItemIcon>
                 <SummarizeOutlinedIcon/>                      
              </ListItemIcon>
                  <ListItemText primary={
                      <Typography variant="h6" style={{ color: "black" }}>
                          Summary
                      </Typography>
                  } />
              </ListItem>
          
            {permissions.CreateTasks==1 && <ListItem button onClick={() => setComponent('tasks')}>
              <ListItemIcon>
                 <AccountBalanceOutlinedIcon/>
              </ListItemIcon>
                  <ListItemText primary={
                      <Typography variant="h6" style={{ color: "black" }}>
                          Tasks
                      </Typography>
                  } />
          </ListItem>}
 
          {permissions.ViewUser==1 && <ListItem button onClick={() => setComponent('users')}>
              <ListItemIcon>
                 <PersonOutlineIcon />
              </ListItemIcon>
                  <ListItemText primary={
                      <Typography variant="h6" style={{ color: "black" }}>
                          Users
                      </Typography>
                  } />
          </ListItem>}

          {permissions.ViewSOW==1 && <ListItem button onClick={() => setComponent('site')}>
              <ListItemIcon>
                 <AccountBalanceOutlinedIcon/>
              </ListItemIcon>
                  <ListItemText primary={
                      <Typography variant="h6" style={{ color: "black" }}>
                          Site
                      </Typography>
                  } />
          </ListItem>}

          {permissions.CreateUser==1 &&<ListItem button onClick={() => setComponent('report')}>
              <ListItemIcon>
                 <ReceiptIcon />
              </ListItemIcon>
                  <ListItemText primary={
                      <Typography variant="h6" style={{ color: "black" }}>
                          Reports
                      </Typography>
                  } />
          </ListItem>}
              {permissions.CreateUser == 1 && <ListItem button onClick={() => setComponent('import')}>
                  <ListItemIcon>
                      <PostAddOutlinedIcon />
                  </ListItemIcon>
                  <ListItemText primary={
                      <Typography variant="h6" style={{ color: "black" }}>
                          Import Data
                      </Typography>
                  } />
              </ListItem>}
          
           {permissions.CreateEvent == 1 &&<ListItem button onClick={() => setComponent('events')}>
              <ListItemIcon>
                 <CalendarTodayOutlinedIcon/>
              </ListItemIcon>
                  <ListItemText primary={
                      <Typography variant="h6" style={{ color: "black" }}>
                          Events
                      </Typography>
                  } />
          </ListItem>}

      </List>
    </div>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
           <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
            ml: { sm: `${drawerWidth}px` },
            top: 'auto',
            bottom: 0
        }}
      >
              {/*        <Toolbar className="adminBar">
          <Typography variant="h6" noWrap component="div" style={{ color: "white" }}>
            Beyondtime Admin
          </Typography>
        </Toolbar> */}
      </AppBar> 
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          className="AdminDrawer"
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          className="AdminDrawer"
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
          <Box
        component="main"
        sx={{ width: { sm: `calc(100% - ${drawerWidth}px)` } }}
      >
              {
				  component === 'home' ?
                      <Home />    
                  :
                  component === 'summary' ?
                      <SummaryTabs />    
                  :
                    component === 'users' ?
                    <div>
                        <UserTabs />
                    </div>
                  :
                    component === 'site' ?
                    <div>
                        <BillingTabs />
                    </div>
                  :
                   component === 'tasks' ?
                    <div>
                        <TaskTabs />
                    </div>
                    :
                   component === 'report' ?
                    <div>
                        <ReportTabs />
                    </div>
                    :  
                    component === 'import' ?
                     <div>
                      <ImportTabs />
                     </div>
                    :  
                    component === 'events' ?
                     <div>
                      <EventTabs />
                     </div>            :  
                  <h1> This Component is under construction </h1> 
                                 
              }
      </Box>
    </Box>
  );
}


export default ResponsiveDrawer;